const DocumentNumberingIndex = () => import('./index.vue');
const DocumentNumberingSetup = () => import('./_pages/setup.vue');
export default [
    {
        path: '/document-numbering',
        component: DocumentNumberingIndex
    },
    {
        path: '/document-numbering/:id',
        component: DocumentNumberingSetup
    }
]